import React from 'react';
import { Send, Pencil, Clock, CalendarClock, CheckCircle2, AlertTriangle, Bell } from 'lucide-react';

// Vocabolario UNICO dello stato di posting (allineato a backend/posting_status.py).
// Icone vettoriali (Lucide), mai emoji; l'icona accompagna SEMPRE l'etichetta testuale.
export const POSTING_STYLE = {
  bozza:        { bg:'var(--bg3)',             color:'var(--text-muted)', label:'Bozza',        Icon:Pencil,        desc:'in lavorazione' },
  pronta:       { bg:'var(--yellow-dim)',      color:'var(--yellow)', label:'Pronta',       Icon:Clock,         desc:'da programmare' },
  programmata:  { bg:'var(--cyan-dim)',        color:'var(--cyan)',   label:'Programmata',  Icon:CalendarClock, desc:'in coda su PostProxy' },
  pubblicata:   { bg:'var(--green-dim)',       color:'var(--green)',  label:'Pubblicata',   Icon:CheckCircle2,  desc:'online' },
  da_risolvere: { bg:'var(--red-dim)',         color:'var(--red)',    label:'Da risolvere', Icon:AlertTriangle, desc:'richiede un intervento' },
  reminder:     { bg:'var(--purple-dim)',      color:'var(--purple)', label:'Reminder',     Icon:Bell,          desc:'post manuale a calendario' },
};

// Stati che richiedono un'azione dell'utente → chip sempre evidenziati.
const AZIONE = ['pronta', 'da_risolvere'];
// Ordine di lettura: prima ciò che richiede azione, poi lo stato di avanzamento.
const ORDER = ['pronta', 'da_risolvere', 'reminder', 'programmata', 'pubblicata'];

export function PostingBadge({ stato, manca }) {
  const s = POSTING_STYLE[stato];
  if (!s) return null;
  const Icon = s.Icon;
  const tip = (manca && manca.length) ? `${s.label} · manca: ${manca.join(', ')}` : `${s.label} — ${s.desc}`;
  return (
    <span title={tip} style={{ display:'inline-flex', alignItems:'center', gap:5, fontSize:11.5, padding:'3px 9px', borderRadius:999, background:s.bg, color:s.color, fontWeight:600, whiteSpace:'nowrap' }}>
      <Icon size={12} strokeWidth={2.4} /> {s.label}
    </span>
  );
}

/**
 * Barra guardrail condivisa da PED e PED Storie.
 * Un solo colpo d'occhio: quanti contenuti in ogni stato, cosa richiede azione,
 * e l'unica azione primaria (Programma tutte le pronte). I chip filtrano la lista.
 */
export function PostingGuardrail({ conteggi = {}, filtro = '', onFiltro, pronte = 0, onProgrammaTutte, publishing = false }) {
  const visibili = ORDER.filter(k => (conteggi[k] || 0) > 0);
  if (!visibili.length) return null;
  const daFare = (conteggi.pronta || 0) + (conteggi.da_risolvere || 0);

  return (
    <div style={{ border:'1px solid var(--border)', background:'var(--surface)', borderRadius:12, padding:'10px 12px', marginBottom:16 }}>
      <div style={{ display:'flex', alignItems:'center', gap:10, flexWrap:'wrap' }}>
        <div className="eden-scroll-row" style={{ flex:'1 1 auto', minWidth:0 }}>
          {visibili.map(k => {
            const s = POSTING_STYLE[k];
            const Icon = s.Icon;
            const on = filtro === k;
            const azione = AZIONE.includes(k);
            return (
              <button key={k} onClick={() => onFiltro(on ? '' : k)} aria-pressed={on}
                title={on ? 'Mostra tutti' : `Filtra: ${s.label} — ${s.desc}`}
                className={`eden-chip${on ? ' is-on' : ''}`}
                style={{ borderColor: on ? s.color : undefined, background: on ? s.bg : undefined, color: (on || azione) ? s.color : undefined }}>
                <Icon size={14} strokeWidth={2.3} />
                <b style={{ fontVariantNumeric:'tabular-nums' }}>{conteggi[k]}</b>
                <span style={{ fontWeight:500 }}>{s.label.toLowerCase()}</span>
              </button>
            );
          })}
          {filtro && (
            <button onClick={() => onFiltro('')} className="eden-chip" title="Rimuovi il filtro">Tutti</button>
          )}
        </div>
        {pronte > 0 && (
          <button onClick={onProgrammaTutte} disabled={publishing} className="eden-btn is-primary"
            title="Programma su PostProxy tutti i contenuti pronti" style={{ marginLeft:'auto' }}>
            <Send size={15}/> {publishing ? 'Programmo…' : `Programma le pronte (${pronte})`}
          </button>
        )}
      </div>
      {daFare > 0 && (
        <div style={{ marginTop:8, fontSize:12.5, color:'var(--text-muted)' }}>
          <b style={{ color:'var(--text)' }}>{daFare}</b> {daFare === 1 ? 'contenuto richiede' : 'contenuti richiedono'} la tua attenzione: tocca un filtro per vederli.
        </div>
      )}
    </div>
  );
}
